
































































import { getConfig } from '@superbet-group/web.lib.config';
import { SdsButtonText } from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

import { getPrintUrls } from '../printLinksHelpers';

import FooterColumnsTitle from './FooterColumnsTitle.vue';

export default defineComponent({
    setup() {
        let hasPrintPdfAvailable = false;
        let offers: Record<string, string> = {};

        const offerNames = getConfig().countrySpecific.footer.offers;
        if (offerNames) {
            offers = { ...offers, ...getPrintUrls(offerNames) };
            hasPrintPdfAvailable = true;
        }

        const outrightsUrl = getConfig().printPdfUrls?.outrights;
        if (outrightsUrl) {
            offers.outrights = outrightsUrl;
            hasPrintPdfAvailable = true;
        }

        return {
            offers,
            hasPrintPdfAvailable,
        };
    },
    components: {
        FooterColumnsTitle,
        SdsButtonText,
    },
});
